import { type ButtonHTMLAttributes, type ReactNode } from 'react'

import type { TProduto } from '@/features/produtos/interfaces/produto.types'
import { Icon } from '@/shared/components/icon'
import { Badge } from '@/shared/components/ui/badge'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/shared/components/ui/tooltip'
import { cn } from '@/shared/lib'
import { configuracaoPorStatusProduto } from '@/shared/utils/status-config'

interface IVagaPadrapCardProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  produto: TProduto
  nomeAgrupador: string
  handleSelecionarProduto: (produto: TProduto, nomeVaga: string) => void
  isSelected: boolean
  tooltip?: ReactNode
}

export const ProdutoCard = ({
  produto,
  isSelected,
  handleSelecionarProduto,
  tooltip,
  nomeAgrupador,
  className,
  ...props
}: IVagaPadrapCardProps) => {
  const variant = configuracaoPorStatusProduto[produto.tipoLegendaStatus].variant

  const onCardClick = () => {
    handleSelecionarProduto(produto, nomeAgrupador)
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge
          data-selected={isSelected}
          data-status={produto.status}
          className={cn(
            'font-nunito text-md relative flex min-h-20 w-full flex-grow basis-1/7 cursor-pointer items-center justify-center rounded-md border p-2 text-center font-semibold duration-250 hover:-translate-y-0.5',
            className,
          )}
          variant={variant}
          asChild
        >
          <button onClick={onCardClick} {...props}>
            <span className="overflow-hidden text-wrap break-words">{produto.descricao}</span>
            {produto.altaProcura && (
              <div className="absolute right-2 bottom-2">
                <Icon
                  data-selected={isSelected}
                  name="flame"
                  className="text-destructive data-[selected=true]:text-red-500"
                />
              </div>
            )}
          </button>
        </Badge>
      </TooltipTrigger>
      {!!tooltip && (
        <TooltipContent side="top" sideOffset={-5}>
          {tooltip}
        </TooltipContent>
      )}
    </Tooltip>
  )
}
